import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';
import styled from 'styled-components';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';
import { useLocation } from '@reach/router';
import FoxImg from '@assets/onboarding/fox-banner.png';
import FoxText from '@assets/onboarding/fox-affiliate-text.png';
import MinimogImg from '@assets/onboarding/minimog.png';
import MegamogImg from '@assets/onboarding/megamog.png';
import FoxifyImg from '@assets/onboarding/foxify.png';
import AffiliateImg from '@assets/onboarding/Affiliate.jpg';
import FoxifyBg from '@assets/onboarding/foxify-bg.jpg';
import MinimigBg from '@assets/onboarding/minimog-bg.jpg';
import MegamogBg from '@assets/onboarding/megamog-bg.jpg';
import FoxBg from '@assets/onboarding/fox-bg.jpg';
import FoxBrand from '@assets/onboarding/fox-brand.png';

const ReviewStyle = styled.div`
  display: flex;
  flex-flow: column;
  gap: 16px;
  color: ${(e) => e.color ?? '#000'};
  .text {
    font-size: 24px;
    line-height: 1.5;
    color: currentColor;
    font-weight: bold;
  }
  .author {
    font-size: 15px;
    font-weight: 600;
  }
  .rating {
    gap: 2px;
  }
  @media (max-height: 900px) {
    .text {
      font-size: 18px;
    }
  }
  @media (max-height: 800px) {
    .text {
      font-size: 16px;
    }
  }
  @media (max-height: 750px) {
    display: none;
  }
`;

const SliderStyle = styled.div`
  --swiper-theme-color: #000;
  height: 100%;
  display: flex;
  flex-flow: column;
  position: relative;
  .slider-container {
    height: 100%;
    .swiper {
      height: 100%;
    }
  }
  .slider-controls {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 24px;
    position: absolute;
    bottom: 30px;
    left: 30px;
    right: 30px;
    z-index: 111;
  }
  .swiper-navigation {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .swiper-pagination {
    position: absolute;
    bottom: 50px;
    left: 30px;
    top: auto;
    right: 140px;
    width: auto;
  }
  .swiper-button {
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 50%;
    width: 42px;
    height: 42px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #000;
    transition: 0.2s all;
    &:hover {
      background: #000;
      color: #fff;
      border-color: #000;
    }
    svg {
      color: currentColor;
    }
  }
  .grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 18px;
  }
  .card {
    display: flex;
    align-items: flex-start;
    flex-flow: column;
    gap: 12px;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0px 24px 24px 0px rgba(0, 0, 0, 0.04);
    background: #fff;
    position: relative;
    &:has(a:hover) {
      a {
        background: #000;
        color: #fff;
      }
      h3 {
        color: #ff5c00;
      }
    }
    h3 {
      font-size: 18px;
      font-weight: bold;
      line-height: 1.5;
      flex: 1;
      transition: 0.2s all;
    }
    a {
      display: flex;
      width: 42px;
      height: 42px;
      justify-content: center;
      align-items: center;
      border-radius: 60px;
      background: #ffd8c3;
      cursor: pointer;
      transition: 0.2s all;
      color: #000;
      &:before {
        content: '';
        position: absolute;
        inset: 0;
      }
    }
  }
  &:has(.swiper-slide-active[data-theme='dark']) {
    --swiper-theme-color: #ff5c00;
    --swiper-pagination-progressbar-bg-color: #fff;
    .swiper-button:hover {
      background: #ff5c00;
      color: #fff;
      border-color: #ff5c00;
    }
  }
  @media (max-height: 800px) {
    .slider-controls {
      bottom: 16px;
    }
    .swiper-pagination {
      bottom: 36px;
    }
  }
`;

const SlideInnerStyle = styled.div`
  padding: 120px 30px 110px;
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-flow: column;
  position: relative;
  gap: 16px;
  > a {
    position: absolute;
    inset: 0;
    z-index: 1;
  }
  .inner {
    display: flex;
    flex-flow: column;
    gap: 55px;
  }
  .image-inner {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-flow: column;
    gap: 20px;
    margin: 0 -30px;
  }
  .fox-affiliate & {
    .image-inner {
      position: relative;
      svg {
        position: absolute;
        bottom: 30px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
  @media (min-height: 1200px) {
    padding-top: 20vh;
  }
  @media (max-height: 900px) {
    padding-top: 50px;
  }
  @media (max-height: 1050px) {
    .fox-affiliate & {
      padding-top: 50px;
      .image-inner img:nth-child(2) {
        width: 450px;
      }
    }
  }
  @media (max-height: 1000px) {
    .foxify-app & {
      padding-top: 50px;
      .image-inner img:nth-child(2) {
        width: 450px;
      }
    }
  }
  @media (max-height: 800px) {
    padding-top: 30px !important;
    .fox-affiliate & {
      .image-inner img:nth-child(2) {
        width: 400px;
      }
      .image-inner svg {
        bottom: 0;
      }
    }
  }
`;

const BgImage = styled.div`
  width: 100%;
  height: 100%;
  pointer-events: none;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  background: ${(e) => e.color};
  img {
    position: absolute;
    width: 100%;
    height: ${(e) => (e.full ? '100%' : 'auto')};
    object-position: top;
    object-fit: cover;
  }
`;

const PreloadImages = () => {
  return (
    <>
      <link rel="preload" href={FoxImg} as="image" />
      <link rel="preload" href={FoxText} as="image" />
      <link rel="preload" href={MinimogImg} as="image" />
      <link rel="preload" href={MegamogImg} as="image" />
      <link rel="preload" href={AffiliateImg} as="image" />
      <link rel="preload" href={FoxifyBg} as="image" />
      <link rel="preload" href={MinimigBg} as="image" />
      <link rel="preload" href={MegamogBg} as="image" />
      <link rel="preload" href={FoxBg} as="image" />
      <link rel="preload" href={FoxBrand} as="image" />
    </>
  );
};

const Review = ({ color = '#000', content, reviewer }) => {
  return (
    <ReviewStyle color={color}>
      <div className="rating flex">
        <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9 0L11.3911 5.70892L17.5595 6.21885L12.8689 10.2571L14.2901 16.2812L9 13.068L3.70993 16.2812L5.1311 10.2571L0.440492 6.21885L6.60889 5.70892L9 0Z"
            fill="#FF5C00"
          />
        </svg>
        <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9 0L11.3911 5.70892L17.5595 6.21885L12.8689 10.2571L14.2901 16.2812L9 13.068L3.70993 16.2812L5.1311 10.2571L0.440492 6.21885L6.60889 5.70892L9 0Z"
            fill="#FF5C00"
          />
        </svg>
        <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9 0L11.3911 5.70892L17.5595 6.21885L12.8689 10.2571L14.2901 16.2812L9 13.068L3.70993 16.2812L5.1311 10.2571L0.440492 6.21885L6.60889 5.70892L9 0Z"
            fill="#FF5C00"
          />
        </svg>
        <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9 0L11.3911 5.70892L17.5595 6.21885L12.8689 10.2571L14.2901 16.2812L9 13.068L3.70993 16.2812L5.1311 10.2571L0.440492 6.21885L6.60889 5.70892L9 0Z"
            fill="#FF5C00"
          />
        </svg>
        <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M9 0L11.3911 5.70892L17.5595 6.21885L12.8689 10.2571L14.2901 16.2812L9 13.068L3.70993 16.2812L5.1311 10.2571L0.440492 6.21885L6.60889 5.70892L9 0Z"
            fill="#FF5C00"
          />
        </svg>
      </div>
      <div className="text">“{content}”</div>
      <div className="author">{reviewer}</div>
    </ReviewStyle>
  );
};

const Quote = () => {
  const [swiper, setSwiper] = useState(null);
  const location = useLocation();

  const isSignUpPage = location.pathname.includes('/signup');

  return (
    <>
      <PreloadImages />
      <SliderStyle className="User-Layout__slider">
        <div className="slider-container">
          <Swiper
            spaceBetween={0}
            modules={[Navigation, Pagination, Autoplay, EffectFade]}
            slidesPerView={1}
            effect={'fade'}
            loop={true}
            fadeEffect={{
              crossFade: true,
            }}
            autoplay={{
              delay: 3500,
              pauseOnMouseEnter: true,
              disableOnInteraction: false,
            }}
            pagination={{ clickable: true, type: 'progressbar' }}
            onSlideChange={() => console.log('slide change')}
            onSwiper={(swiper) => setSwiper(swiper)}
          >
            <SwiperSlide className={'fox-affiliate'}>
              <SlideInnerStyle>
                <a href="https://foxecom.com/pages/affiliate" target={'_blank'} />
                <div className="image-inner">
                  <img src={FoxText} width={444} alt="FoxEom Affiliate Program" />
                  <img src={FoxImg} style={{ transform: 'translateX(-20px)' }} width={600} alt="FoxEom Products" />
                  <svg width="172" height="50" viewBox="0 0 172 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="172" height="50" rx="8" fill="black" />
                    <path
                      d="M48.7163 29H41.4523V17.304H48.7163V19.192H43.5003V22.2H48.1723V24.008H43.5003V27.112H48.7163V29ZM52.0246 29H49.8006L52.5206 25.128L49.8006 21.096H52.0726L53.8166 23.784L55.4966 21.096H57.6886L55.0006 25.096L57.6086 29H55.3686L53.6886 26.392L52.0246 29ZM58.8518 32.664V21.096H60.6598L60.7878 22.296C61.2678 21.384 62.3078 20.856 63.5078 20.856C65.7318 20.856 67.2038 22.472 67.2038 24.952C67.2038 27.416 65.8598 29.208 63.5078 29.208C62.3238 29.208 61.2998 28.744 60.8038 27.944V32.664H58.8518ZM60.8198 25.048C60.8198 26.472 61.6998 27.448 63.0438 27.448C64.4198 27.448 65.2358 26.456 65.2358 25.048C65.2358 23.64 64.4198 22.632 63.0438 22.632C61.6998 22.632 60.8198 23.624 60.8198 25.048ZM70.726 29H68.79V17.096H70.726V29ZM72.3096 25.032C72.3096 22.568 74.0856 20.872 76.5336 20.872C78.9816 20.872 80.7576 22.568 80.7576 25.032C80.7576 27.496 78.9816 29.192 76.5336 29.192C74.0856 29.192 72.3096 27.496 72.3096 25.032ZM74.2616 25.032C74.2616 26.472 75.1896 27.448 76.5336 27.448C77.8776 27.448 78.8056 26.472 78.8056 25.032C78.8056 23.592 77.8776 22.616 76.5336 22.616C75.1896 22.616 74.2616 23.592 74.2616 25.032ZM87.2649 21.064V22.872H86.5449C85.1369 22.872 84.2569 23.624 84.2569 25.16V29H82.3049V21.112H84.1449L84.2569 22.264C84.5929 21.48 85.3449 20.952 86.4009 20.952C86.6729 20.952 86.9449 20.984 87.2649 21.064ZM91.8565 29.208C89.5045 29.208 87.8565 27.496 87.8565 25.048C87.8565 22.568 89.4725 20.856 91.7925 20.856C94.1605 20.856 95.6645 22.44 95.6645 24.904V25.496L89.7125 25.512C89.8565 26.904 90.5925 27.608 91.8885 27.608C92.9605 27.608 93.6645 27.192 93.8885 26.44H95.6965C95.3605 28.168 93.9205 29.208 91.8565 29.208ZM91.8085 22.456C90.6565 22.456 89.9525 23.08 89.7605 24.264H93.7285C93.7285 23.176 92.9765 22.456 91.8085 22.456ZM103.491 29H101.539V21.096H103.347L103.507 22.12C104.003 21.32 104.963 20.856 106.035 20.856C108.019 20.856 109.043 22.088 109.043 24.136V29H107.091V24.6C107.091 23.272 106.435 22.632 105.427 22.632C104.227 22.632 103.491 23.464 103.491 24.744V29ZM110.497 25.032C110.497 22.568 112.273 20.872 114.721 20.872C117.169 20.872 118.945 22.568 118.945 25.032C118.945 27.496 117.169 29.192 114.721 29.192C112.273 29.192 110.497 27.496 110.497 25.032ZM112.449 25.032C112.449 26.472 113.377 27.448 114.721 27.448C116.065 27.448 116.993 26.472 116.993 25.032C116.993 23.592 116.065 22.616 114.721 22.616C113.377 22.616 112.449 23.592 112.449 25.032ZM121.846 29L119.286 21.096H121.318L122.358 24.488C122.534 25.112 122.694 25.8 122.838 26.536C122.982 25.768 123.126 25.272 123.382 24.488L124.47 21.096H126.454L127.51 24.488C127.606 24.808 127.926 25.992 128.022 26.52C128.15 25.928 128.406 24.984 128.55 24.488L129.606 21.096H131.67L128.934 29H127.11L126.022 25.576C125.702 24.536 125.526 23.784 125.462 23.384C125.382 23.752 125.238 24.312 124.838 25.608L123.75 29H121.846Z"
                      fill="white"
                    />
                  </svg>
                </div>
                <Review
                  content={
                    'I love everything about FoxEcom! I am using their Shopify theme, Minimog with their apps FoxKit and the page builder Foxify. They are very easy to use and have improved our site a lot.'
                  }
                  reviewer={'Gary Watts, United Kingdom'}
                />
                <BgImage full color={'#000'}>
                  <img src={AffiliateImg} alt="FoxEom Affiliate Program" />
                </BgImage>
              </SlideInnerStyle>
            </SwiperSlide>
            {isSignUpPage ? (
              <>
                <SwiperSlide className={'minimog-theme'} data-theme={'dark'}>
                  <SlideInnerStyle>
                    <a href="https://foxecom.com/products/minimog-shopify-theme" target={'_blank'} />
                    <div className="image-inner">
                      <img src={MinimogImg} width={420} alt="Minimog theme" />
                    </div>
                    <Review
                      content={
                        'Really impressed with the quality of the theme and customer support. There are many options to customize the theme, very good and flexible. Customer support is quick and on point.'
                      }
                      reviewer={'Raeesahmed, United Kingdom'}
                      color={'#fff'}
                    />
                    <BgImage color={'#000'}>
                      <img src={MinimigBg} alt="Minimog theme" />
                    </BgImage>
                  </SlideInnerStyle>
                </SwiperSlide>
                <SwiperSlide className={'megamog-theme'} data-theme={'light'}>
                  <SlideInnerStyle>
                    <a href="https://foxecom.com/products/megamog-shopify-theme" target={'_blank'} />
                    <div className="image-inner">
                      <img width={340} src={MegamogImg} alt="Megamog theme" />
                    </div>
                    <Review
                      content={
                        'Superb service! They have great themes, with beneficial features that can help increase your conversion rate. Their customer support is extremely helpful and very responsive.'
                      }
                      reviewer={'J.Fuller, United States'}
                    />
                    <BgImage color={'#fff'}>
                      <img src={MegamogBg} alt="Megamog theme" />
                    </BgImage>
                  </SlideInnerStyle>
                </SwiperSlide>
              </>
            ) : (
              <>
                <SwiperSlide className={'fox-brand'} data-theme={'light'}>
                  <SlideInnerStyle>
                    <div className={'inner'}>
                      <div className="image-inner">
                        <img width={300} src={FoxBrand} alt="FoxEcom" />
                      </div>
                      <div className="grid">
                        <div className="card">
                          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_4622_1158)">
                              <path
                                d="M37.4616 14.1888C37.4616 14.206 37.4616 14.2216 37.4507 14.2388L33.9069 30.4685C33.7979 31.04 33.4929 31.5555 33.0445 31.9263C32.5961 32.2971 32.0325 32.4999 31.4507 32.4997H8.54913C7.96759 32.4995 7.40432 32.2966 6.95629 31.9258C6.50825 31.5551 6.20348 31.0397 6.09445 30.4685L2.5507 14.2388C2.5507 14.2216 2.54288 14.206 2.53976 14.1888C2.44277 13.6515 2.52437 13.0971 2.77209 12.6105C3.01981 12.1239 3.42003 11.7318 3.91159 11.4941C4.40315 11.2564 4.95902 11.1861 5.49427 11.2941C6.02952 11.402 6.51471 11.6823 6.8757 12.0919L12.1366 17.7622L17.7304 5.21692C17.7306 5.21172 17.7306 5.2065 17.7304 5.2013C17.9304 4.76747 18.2505 4.40003 18.6529 4.14247C19.0553 3.88492 19.523 3.74805 20.0007 3.74805C20.4784 3.74805 20.9461 3.88492 21.3485 4.14247C21.7508 4.40003 22.071 4.76747 22.271 5.2013C22.2707 5.2065 22.2707 5.21172 22.271 5.21692L27.8648 17.7622L33.1257 12.0919C33.4874 11.6853 33.972 11.4078 34.5058 11.3016C35.0396 11.1954 35.5934 11.2663 36.0832 11.5036C36.5731 11.7408 36.9721 12.1314 37.2198 12.616C37.4674 13.1006 37.5501 13.6529 37.4554 14.1888H37.4616Z"
                                fill="url(#paint0_linear_4622_1158)"
                              />
                            </g>
                            <defs>
                              <linearGradient
                                id="paint0_linear_4622_1158"
                                x1="30.891"
                                y1="5.3755"
                                x2="14.1228"
                                y2="31.5561"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stop-color="#FF670E" />
                                <stop offset="1" stop-color="#FFAD66" />
                              </linearGradient>
                              <clipPath id="clip0_4622_1158">
                                <rect width="40" height="40" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          <h3>Read what's new in FoxEcom</h3>
                          <a href="https://help.foxecom.com/" target={'_blank'}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M3.125 10H16.875" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <path
                                d="M11.25 4.375L16.875 10L11.25 15.625"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </a>
                        </div>
                        <div className="card">
                          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_4622_1169)">
                              <path
                                d="M37.4998 24.9998C37.4979 28.1148 36.333 31.1169 34.2333 33.4179C32.1335 35.719 29.2503 37.1531 26.1485 37.4393C23.0466 37.7256 19.9496 36.8434 17.4642 34.9655C14.9789 33.0876 13.2842 30.3494 12.7123 27.2873C14.7074 27.6584 16.7628 27.5381 18.701 26.937C20.6392 26.3358 22.4019 25.2718 23.8369 23.8369C25.2718 22.4019 26.3358 20.6392 26.937 18.701C27.5381 16.7628 27.6584 14.7074 27.2873 12.7123C30.1561 13.2463 32.7477 14.7672 34.613 17.0114C36.4782 19.2556 37.4995 22.0817 37.4998 24.9998ZM24.9998 12.4998C25.7672 12.5005 26.5329 12.5716 27.2873 12.7123C26.8709 10.4739 25.8511 8.39165 24.3379 6.69043C22.8247 4.98921 20.8756 3.7336 18.701 3.05912C16.5264 2.38464 14.2089 2.31692 11.9986 2.86326C9.78827 3.4096 7.76917 4.54926 6.15921 6.15921C4.54926 7.76917 3.4096 9.78827 2.86326 11.9986C2.31692 14.2089 2.38464 16.5264 3.05912 18.701C3.7336 20.8756 4.98921 22.8247 6.69043 24.3379C8.39165 25.8511 10.4739 26.8709 12.7123 27.2873C12.3764 25.4831 12.442 23.6271 12.9043 21.851C13.3666 20.075 14.2142 18.4226 15.3871 17.0111C16.56 15.5996 18.0293 14.4636 19.6906 13.684C21.3519 12.9043 23.1646 12.5 24.9998 12.4998Z"
                                fill="url(#paint0_linear_4622_1169)"
                              />
                            </g>
                            <defs>
                              <linearGradient
                                id="paint0_linear_4622_1169"
                                x1="30.8957"
                                y1="4.47885"
                                x2="9.10798"
                                y2="32.4347"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stop-color="#FF670E" />
                                <stop offset="1" stop-color="#FFAD66" />
                              </linearGradient>
                              <clipPath id="clip0_4622_1169">
                                <rect width="40" height="40" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          <h3>Explore hot eCommerce reads</h3>
                          <a href="https://foxecom.com/blogs/all" target={'_blank'}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M3.125 10H16.875" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <path
                                d="M11.25 4.375L16.875 10L11.25 15.625"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </a>
                        </div>
                        <div className="card">
                          <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_4622_1180)">
                              <path
                                d="M20 3.75C16.7861 3.75 13.6443 4.70305 10.972 6.48862C8.29969 8.27419 6.21689 10.8121 4.98696 13.7814C3.75704 16.7507 3.43524 20.018 4.06225 23.1702C4.68926 26.3224 6.23692 29.2179 8.50952 31.4905C10.7821 33.7631 13.6776 35.3107 16.8298 35.9378C19.982 36.5648 23.2493 36.243 26.2186 35.013C29.1879 33.7831 31.7258 31.7003 33.5114 29.028C35.297 26.3557 36.25 23.2139 36.25 20C36.2455 15.6916 34.5319 11.561 31.4855 8.51454C28.439 5.46806 24.3084 3.75455 20 3.75ZM26.3359 21.0281L18.2109 26.6531C18.0234 26.7828 17.8039 26.8587 17.5763 26.8727C17.3486 26.8866 17.1215 26.8379 16.9196 26.7321C16.7176 26.6262 16.5484 26.467 16.4304 26.2719C16.3124 26.0768 16.25 25.8531 16.25 25.625V14.375C16.25 14.1469 16.3124 13.9232 16.4304 13.7281C16.5484 13.533 16.7176 13.3738 16.9196 13.2679C17.1215 13.1621 17.3486 13.1134 17.5763 13.1273C17.8039 13.1413 18.0234 13.2172 18.2109 13.3469L26.3359 18.9719C26.5022 19.0869 26.6382 19.2405 26.7321 19.4196C26.8259 19.5986 26.875 19.7978 26.875 20C26.875 20.2022 26.8259 20.4014 26.7321 20.5804C26.6382 20.7595 26.5022 20.9131 26.3359 21.0281Z"
                                fill="url(#paint0_linear_4622_1180)"
                              />
                            </g>
                            <defs>
                              <linearGradient
                                id="paint0_linear_4622_1180"
                                x1="30.1179"
                                y1="5.58962"
                                x2="9.88208"
                                y2="31.5487"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stop-color="#FF670E" />
                                <stop offset="1" stop-color="#FFAD66" />
                              </linearGradient>
                              <clipPath id="clip0_4622_1180">
                                <rect width="40" height="40" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>

                          <h3>Get the best with our Help articles</h3>
                          <a href="https://docs.foxecom.com/" target={'_blank'}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M3.125 10H16.875" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                              <path
                                d="M11.25 4.375L16.875 10L11.25 15.625"
                                stroke="currentColor"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </a>
                        </div>
                      </div>
                    </div>
                    <Review
                      content={
                        "This is seriously one of the best I have ever worked with. I wish I had discovered it earlier. There are so many options and if you can't figure it out they are always and quickly there for you."
                      }
                      reviewer={'Jacky Rhemrev, Netherlands'}
                      color={'#000'}
                    />
                    <BgImage full color={'#fff'}>
                      <img src={FoxBg} alt="FoxEcom" />
                    </BgImage>
                  </SlideInnerStyle>
                </SwiperSlide>
                <SwiperSlide className={'foxify-app'} data-theme={'dark'}>
                  <SlideInnerStyle data-theme={'dark'}>
                    <a href="https://foxecom.com/products/foxify-shopify-app" target={'_blank'} />
                    <div className="image-inner">
                      <img src={FoxifyImg} alt="Foxify app" />
                    </div>
                    <Review
                      content={
                        'Let me just say that its one thing to have a great product, but to then back it up with unbelievable customer support - is next level.'
                      }
                      reviewer={'Graceful Lily, Australia'}
                      color={'#fff'}
                    />
                    <BgImage color={'#000'}>
                      <img src={FoxifyBg} alt="Foxify app" />
                    </BgImage>
                  </SlideInnerStyle>
                </SwiperSlide>
              </>
            )}
          </Swiper>
        </div>
        <div className="slider-controls">
          <div className={'swiper-navigation'}>
            <button className="swiper-button" onClick={() => swiper?.slidePrev()}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.875 10H3.125" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path stroke={'currentColor'} d="M8.75 4.375L3.125 10L8.75 15.625" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
            <button className="swiper-button" onClick={() => swiper?.slideNext()}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.125 10H16.875" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                  stroke={'currentColor'}
                  d="M11.25 4.375L16.875 10L11.25 15.625"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
      </SliderStyle>
    </>
  );
};

export default Quote;
